// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-vUa4llQIYqbUmNbdpBkZ"};